import { setGetLandingsByIdAction } from '../action';
import { getLandingsById } from '../api/getLandingsById';

export const setGetLandingsById = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getLandingsById(params);
            dispatch(setGetLandingsByIdAction(data.data))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}